var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.085 13.5.666-4.343H9.584V6.338c0-1.188.582-2.347 2.448-2.347h1.895V.293S12.207 0 10.564 0C7.132 0 4.888 2.08 4.888 5.846v3.31H1.073V13.5h3.815V24h4.696V13.5h3.5Z",
    fill: "#333"
  })));
};
export default SvgFacebook;